import React from "react";

import Stack from "@busbud/design-system-components/dist/Stack";
import type { Choices } from "@busbud/int-schemas/lib";
import type * as UDM from "@busbud/int-schemas/udm";

import { createArrayOfLength } from "@app/utils/array";

import { BusColumn } from "./bus-horizontal-column";

interface Props {
  active_seat?: UDM.SeatCell;
  floor?: UDM.Floor;
  rows_count: number;
  active_seat_id: string | null;
  already_assigned_seat_ids: (string | null)[];
  onSeatChange: (seat: UDM.SeatCell) => void;
  onGenderChange?: (gender: Choices.Gender) => void;
  seatClassResolver?: (seat_id: string) => string | null;
}

export const BusRows: React.FC<Props> = props => {
  const {
    active_seat,
    floor,
    rows_count,
    active_seat_id,
    already_assigned_seat_ids,
    onSeatChange,
    onGenderChange,
    seatClassResolver
  } = props;

  const columns_count = floor?.cells?.[0]?.length || 0;

  return (
    <Stack spacing={0.5} direction="row">
      {createArrayOfLength(rows_count).map((_, row) => (
        <BusColumn
          key={row}
          columns_count={columns_count}
          row={row}
          active_seat={active_seat}
          floor={floor}
          rows_count={rows_count}
          active_seat_id={active_seat_id}
          already_assigned_seat_ids={already_assigned_seat_ids}
          onSeatChange={onSeatChange}
          onGenderChange={onGenderChange}
          seatClassResolver={seatClassResolver}
        />
      ))}
    </Stack>
  );
};
